

import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "@/lib/utils"

function Popover({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "vtwo:bg-popover vtwo:text-popover-foreground vtwo:data-[state=open]:animate-in vtwo:data-[state=closed]:animate-out vtwo:data-[state=closed]:fade-out-0 vtwo:data-[state=open]:fade-in-0 vtwo:data-[state=closed]:zoom-out-95 vtwo:data-[state=open]:zoom-in-95 vtwo:data-[side=bottom]:slide-in-from-top-2 vtwo:data-[side=left]:slide-in-from-right-2 vtwo:data-[side=right]:slide-in-from-left-2 vtwo:data-[side=top]:slide-in-from-bottom-2 vtwo:z-50 vtwo:w-72 vtwo:origin-(--radix-popover-content-transform-origin) vtwo:rounded-md vtwo:border vtwo:p-4 vtwo:shadow-md vtwo:outline-hidden",
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}

function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
